import { Box } from '@mui/material';
import { useGridApiRef } from '@mui/x-data-grid-premium';
import PersistentDataGrid from 'common/PersistentDataGrid';
import * as R from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';

import inventorySummaryColumns from './InventorySummaryColumns';

const InventorySummaryTab = ({ createReconsignmentInventoryDetails }) => {
  const apiRef = useGridApiRef();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 7, pt: 2, width: '100%' }}>
      <PersistentDataGrid
        apiRef={apiRef}
        columns={inventorySummaryColumns}
        disableColumnMenu
        getRowId={R.prop('locationId')}
        getRowSpacing={() => ({
          bottom: 0,
          top: 0,
        })}
        hideFooter
        id="confirmationGrid"
        initialState={{
          aggregation: {
            model: {
              transferVolume: 'sum',
            },
          },
        }}
        rows={createReconsignmentInventoryDetails}
        slots={{
          toolbar: () => <></>,
        }}
      />
    </Box>
  );
};
InventorySummaryTab.propTypes = {
  createReconsignmentInventoryDetails: PropTypes.shape([]).isRequired,
  reconsignmentState: PropTypes.shape({
    fromLocation: PropTypes.shape({}),
  }).isRequired,
};

export default InventorySummaryTab;
